{
  "success": {
    "analyses/setMovable": "분석이 업데이트되었습니다",
    "analyses/moveIntoPlan": "분석이 계획으로 성공적으로 이동되었습니다",
    "analyses/remove": "분석이 성공적으로 미계획으로 전환되었습니다",
    "analysisDefinitions/create": "새 분석 정의가 추가되었습니다",
    "analysisDefinitions/edit": "분석 정의가 편집되었습니다",
    "analysisDefinitions/remove": "분석 정의가 삭제되었습니다",
    "analysisDraft/create": "새 분석 초안이 추가되었습니다",
    "analysisDraft/edit": "분석 초안이 편집되었습니다",
    "samples/delete-unlocked": "모든 미계획 샘플이 삭제되었습니다",
    "assets/remove": "장비가 성공적으로 삭제되었습니다",
    "assets/create": "새 장비가 추가되었습니다",
    "assets/edit": "장비가 편집되었습니다",
    "competenceGroups/create": "새 역량 그룹이 성공적으로 생성되었습니다",
    "competenceGroups/edit": "역량 그룹이 성공적으로 편집되었습니다",
    "competenceGroups/remove": "역량 그룹이 성공적으로 삭제되었습니다",
    "iap/run": "IAP가 성공적으로 실행되었습니다",
    "iap/runFillInSamples": "샘플이 성공적으로 채워졌습니다",
    "integrationSheets/createActionSheet": "시트가 추가되었습니다",
    "integrationSheets/createProjectTemplateSheets": "시트가 추가되었습니다",
    "integrationSheets/createSampleSheet": "시트가 추가되었습니다",
    "integrationSheets/editActionSheet": "시트가 편집되었습니다",
    "integrationSheets/editProjectTemplateSheet": "시트가 편집되었습니다",
    "integrationSheets/editSampleSheet": "시트가 편집되었습니다",
    "integrationSheets/removeActionSheet": "시트가 삭제되었습니다",
    "integrationSheets/removeProjectTemplateSheet": "시트가 삭제되었습니다",
    "integrationSheets/removeSampleSheet": "시트가 삭제되었습니다",
    "integrationSheets/saveSapConversionSheet": "프로젝트 가져오기 시트가 저장되었습니다",
    "members/create": "멤버가 추가되었습니다",
    "members/createAsAdmin": "멤버가 추가되었습니다",
    "members/edit": "멤버가 편집되었습니다",
    "members/archive": "멤버가 보관되었습니다",
    "projectActions/editPlanned": "프로젝트 작업이 편집되었습니다",
    "projectActions/move": "프로젝트 작업이 일정에 배치되었습니다",
    "projectActions/setMovable": "프로젝트 작업이 업데이트되었습니다",
    "projectActions/setLocation": "위치가 업데이트되었습니다",
    "projectActions/setLocationUnplanned": "위치가 업데이트되었습니다",
    "projectActions/editUnplanned": "미계획 프로젝트 작업이 편집되었습니다",
    "projectActions/removePlanned": "프로젝트가 미계획으로 전환되었습니다",
    "projects/create": "새 프로젝트가 추가되었습니다",
    "projects/edit": "프로젝트가 업데이트되었습니다",
    "projects/remove": "프로젝트가 삭제되었습니다",
    "projects/delete-unplanned": "모든 미계획 프로젝트가 삭제되었습니다",
    "projects/lockProject": "프로젝트가 잠금되었습니다",
    "projects/unlockProject": "프로젝트 잠금이 해제되었습니다",
    "projectTemplates/create": "새 프로젝트 템플릿이 생성되었습니다",
    "projectTemplates/createDraft": "새 프로젝트 템플릿 초안이 생성되었습니다",
    "projectTemplates/edit": "프로젝트 템플릿이 편집되었습니다",
    "projectTemplates/editDraft": "프로젝트 템플릿 초안이 편집되었습니다",
    "projectTemplates/remove": "프로젝트 템플릿이 삭제되었습니다",
    "whiteTasks/remove": "작업이 성공적으로 삭제되었습니다",
    "whiteTasks/create": "새 작업이 추가되었습니다",
    "whiteTasks/edit": "작업이 성공적으로 편집되었습니다",
    "whiteTasks/createRecurrence": "반복이 생성되었습니다",
    "whiteTasks/removeRecurrence": "반복 작업이 제거되었습니다",
    "teamStatus/start": "시뮬레이션 모드에 진입했습니다",
    "teamStatus/accept": "시뮬레이션 모드 변경사항이 적용되었습니다",
    "teamStatus/discard": "시뮬레이션 모드 변경사항이 취소되었습니다",
    "customers/addCustomer": "고객이 추가되었습니다",
    "customers/editCustomer": "고객이 편집되었습니다",
    "customers/deleteCustomer": "고객이 삭제되었습니다",
    "team/create-api-token": "API 토큰이 생성되었습니다",
    "team/delete-api-token": "API 토큰이 삭제되었습니다"
  },
  "error": {
    "analyses/remove/ERROR": "분석 미계획 전환 실패",
    "analysisDefinitions/create/ERROR": "새 분석 정의 추가 실패",
    "analysisDefinitions/remove/ERROR": "분석 정의 삭제 실패",
    "assets/remove/ERROR": "장비 삭제 실패",
    "assets/create/ERROR": "장비 추가 실패",
    "auth/login/ERROR": "로그인 실패",
    "competenceGroups/create/ERROR": "역량 그룹 생성 실패",
    "competenceGroups/remove/ERROR": "역량 그룹 삭제 실패",
    "iap/run/ERROR": "IAP 실행 실패",
    "iap/runFillInSamples/ERROR": "샘플 채우기 실패",
    "integrationSheets/createActionSheet/ERROR": "시트 추가 실패",
    "integrationSheets/createProjectTemplateSheets/ERROR": "시트 추가 실패",
    "integrationSheets/createSampleSheet/ERROR": "시트 추가 실패",
    "integrationSheets/editActionSheet/ERROR": "시트 편집 실패",
    "integrationSheets/editProjectTemplateSheet/ERROR": "시트 편집 실패",
    "integrationSheets/editSampleSheet/ERROR": "시트 편집 실패",
    "integrationSheets/removeActionSheet/ERROR": "시트 삭제 중 오류가 발생했습니다",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "시트 삭제 중 오류가 발생했습니다",
    "integrationSheets/removeSampleSheet/ERROR": "시트 삭제 중 오류가 발생했습니다",
    "loading/fetchAll/ERROR": "로딩 실패",
    "members/create/ERROR": "멤버 추가 실패",
    "members/createAsAdmin/ERROR": "멤버 추가 실패",
    "members/archive/ERROR": "멤버 보관 실패",
    "projectActions/move/ERROR": "작업 일정 이동 실패",
    "projectActions/removePlanned/ERROR": "작업 미계획 전환 실패",
    "projectActions/setLocation/ERROR": "위치 업데이트 실패",
    "projectActions/setLocationUnplanned/ERROR": "위치 업데이트 실패",
    "projects/create/ERROR": "새 프로젝트 추가 실패",
    "projects/remove/ERROR": "프로젝트 삭제 실패",
    "projects/delete-unplanned/ERROR": "미계획 프로젝트 삭제 실패",
    "projects/lockProject/ERROR": "작업 잠금 실패",
    "projectTemplates/create/ERROR": "새 프로젝트 템플릿 생성 실패",
    "projectTemplates/createDraft/ERROR": "새 프로젝트 템플릿 초안 생성 실패",
    "projectTemplates/remove/ERROR": "프로젝트 템플릿 삭제 실패",
    "whiteTasks/remove/ERROR": "작업 삭제 실패",
    "whiteTasks/create/ERROR": "생성 실패",
    "teamStatus/start/ERROR": "시뮬레이션 모드 진입 실패",
    "teamStatus/accept/ERROR": "시뮬레이션 모드 변경사항 적용 실패",
    "teamStatus/discard/ERROR": "시뮬레이션 모드 변경사항 취소 실패",
    "customers/deleteCustomer/ERROR": "고객을 삭제할 수 없습니다",
    "customers/addCustomer/ERROR": "고객을 추가할 수 없습니다",
    "customers/editCustomer/ERROR": "고객을 편집할 수 없습니다",
    "team/create-api-token/ERROR": "API 토큰을 생성할 수 없습니다",
    "team/delete-api-token/ERROR": "API 토큰을 삭제할 수 없습니다"
  },
  "adhoc": {
    "welcomeBack": "다시 돌아오신 것을 환영합니다!",
    "noSoundDetected": "소리가 감지되지 않습니다. 다시 시도하세요.",
    "noMicrophoneDetected": "마이크가 감지되지 않습니다. 다시 시도하세요.",
    "iapRunning": "잠시만 기다려 주세요 - 팀의 IAP가 실행 중입니다",
    "failedDiscardNotLoggedOut": "변경사항 취소 실패. 로그아웃되지 않았습니다!",
    "cannotDragRecurrentTask": "반복 회색 작업은 드래그 앤 드롭할 수 없습니다",
    "cannotMoveImportedTasks": "가져온 작업은 이동할 수 없습니다",
    "noCheckboxesSelected": "선택된 체크박스가 없습니다",
    "analysisUpdatedRefresh": "분석이 업데이트되었습니다. 새로고침하세요",
    "analysisUpdatedByAnotherUser": "다른 사용자가 분석을 업데이트했습니다. 새로고침하세요",
    "copiedToClipboard": "클립보드에 복사되었습니다",
    "couldNotCopyToClipboard": "클립보드에 복사할 수 없습니다",
    "chooseFirstAction": "첫 번째 {{itemType}}을(를) 선택하세요",
    "chooseSecondAction": "두 번째 {{itemType}}을(를) 선택하세요",
    "chooseTwoDifferent": "서로 다른 두 개의 {{itemType}}을(를) 선택하세요",
    "constraintConflicts": "해당 제약이 기존 제약과 충돌합니다",
    "sampleCreated": "샘플이 생성되었습니다",
    "sampleDeleted": "샘플이 삭제되었습니다",
    "samplesUpdated": "샘플이 업데이트되었습니다",
    "sampleMarkedDone": "샘플이 완료로 표시되었습니다",
    "memberPermissionsChanged": "멤버 권한이 변경되었습니다",
    "chooseUniqueName": "고유한 이름을 선택하세요",
    "fillRequiredFields": "필수 필드를 입력하세요",
    "couldNotDetermineSampleIdDone": "완료 표시할 샘플 ID를 확인할 수 없습니다",
    "couldNotDetermineSampleIdDelete": "삭제할 샘플 ID를 확인할 수 없습니다",
    "couldNotDetermineSampleIdDeleteMissing": "삭제할 샘플 ID를 확인할 수 없습니다 — 데이터 누락. 자세한 내용은 콘솔을 확인하세요.",
    "anErrorOccurred": "오류가 발생했습니다",
    "selectFileBeforeSubmitting": "제출 전에 최소 하나의 파일을 선택하세요",
    "helpPageUpdated": "도움말 페이지가 업데이트되었습니다",
    "processingStarted": "처리가 시작되었습니다",
    "failedLoadingIcalFiles": "iCalendar 파일 로딩 실패",
    "unsortBeforePasting": "여러 셀을 붙여넣기 전에 테이블 정렬을 해제하세요.",
    "fillAllRequiredFields": "모든 필수 필드를 입력하세요",
    "unsavedChangesConfirmLeave": "저장되지 않은 변경사항이 있습니다. 나가려면 뒤로 버튼을 다시 누르세요.",
    "provideSheetName": "시트 이름을 입력하세요",
    "sheetNameAlreadyExists": "해당 이름의 시트가 이미 존재합니다",
    "provideSheetType": "시트 유형을 입력하세요",
    "didNotSpellDeleteProperly": "DELETE를 올바르게 입력하지 않았습니다",
    "domainMustStartWithAt": "도메인은 '@'으로 시작해야 합니다",
    "fillOutRequiredFields": "필수 필드를 작성하세요",
    "selectValidDates": "유효한 날짜를 선택하세요",
    "noIapModeSelected": "IAP 모드가 선택되지 않았습니다. 모드를 선택하세요.",
    "oneCollaboratorForWorkday": "전체 근무일을 선택할 때는 협력자를 한 명만 선택할 수 있습니다",
    "fillRequiredDateTimeFields": "모든 필수 날짜 및 시간 필드를 입력하세요",
    "endMustBeAfterStart": "작업 종료는 시작 이후여야 합니다",
    "recurrencesCannotExceed365": "반복 횟수는 365를 초과할 수 없습니다",
    "pleaseFillNumberAndInterval": "반복 횟수와 간격을 입력하세요",
    "pleaseFillNumberOfRecurrences": "반복 횟수를 입력하세요",
    "pleaseFillIntervalOfRecurrences": "반복 간격을 입력하세요",
    "pleaseFillAllPeriodFields": "모든 기간 필드를 입력하세요",
    "pleaseSelectReportType": "최소 하나의 보고서 유형을 선택하세요",
    "reportEmptyInInterval": "{{fileName}}은(는) 지정된 기간에 비어 있습니다",
    "noSoundDetected": "소리가 감지되지 않습니다. 다시 시도하세요.",
    "noMicrophoneDetected": "마이크가 감지되지 않습니다. 다시 시도하세요.",
    "promptTooLong": "프롬프트가 너무 깁니다 (최대 1200자)",
    "nameTooLong": "이름이 너무 깁니다 (최대 100자)"
  }
}
